export async function getStaticAppSettings(env) {

    if (env === "development") {
        return {
          // Your local development values
          MAPPING_API_URL:"http://localhost:8080"
        }
      }

  // For non-local environments, fetch from /settings/env.json
  const host = window.location.protocol + "//" + window.location.host;
  const response = await fetch(`${host}/settings/env.json`);
  const appEnv = await response.json();
  return appEnv;
}